import axios from 'axios';
import interceptorRequest from '@/services/interceptors/request';
import interceptorResponseSuccess from '@/services/interceptors/responseSuccess';
import interceptorResponseError from '@/services/interceptors/responseError';

const http = axios.create({
  baseURL: process.env.REAL_API_URL,
});

http.interceptors.request.use(interceptorRequest);
http.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError);

function authorizeApi(token) {
  if (token) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
}

export default http;
export { authorizeApi };



// WEBPACK FOOTER //
// ./src/services/api/http.js